import {
    FetchWaitlistCountsResponseDto,
    WaitlistAddonDto,
    WaitlistDto,
    WaitlistServiceDto,
    WaitlistTabCountsDto
} from 'actions/waitlists/WaitlistsDto';
import {
    WAITLIST_SERVICE_KEYS,
    Waitlist,
    WaitlistAddon,
    WaitlistCounts,
    WaitlistService,
    WaitlistServiceKey,
    WaitlistTabCounts
} from 'model/Waitlist';
import moment from 'moment-timezone';

const convertToWaitlistAddon = (dto: WaitlistAddonDto): WaitlistAddon => ({
    id: dto.id,
    addonServiceId: dto.addon_service_id,
    addonServiceName: dto.addon_service_name,
    price: dto.price
});

const convertToWaitlistService = (dto: WaitlistServiceDto): WaitlistService => ({
    id: dto.id,
    petId: dto.pet_id,
    petName: dto.pet_name,
    petImage: dto.pet_image ?? null,
    petType: dto.pet_type ?? '',
    petBreedName: dto.pet_breed_name ?? '',
    petSize: dto.pet_size ?? '',
    petHairLength: dto.pet_hair_length ?? '',
    petWeight: dto.pet_weight ?? null,
    serviceId: dto.service_id,
    serviceName: dto.service_name,
    businessArea: dto.business_area,
    price: dto.price,
    dates: dto.dates ?? [],
    preferredStaffId: dto.preferred_staff_id ?? null,
    preferredStaffName: dto.preferred_staff_name ?? null,
    preferredStaffEligible: dto.preferred_staff_eligible ?? false,
    addons: (dto.waitlist_addons ?? []).map(convertToWaitlistAddon)
});

export const convertToWaitlist = (dto: WaitlistDto, timeZone?: string): Waitlist => ({
    id: dto.id,
    uuid: dto.uuid,
    marketplaceId: dto.marketplace_id,
    marketplaceName: dto.marketplace_name,
    customerId: dto.customer_id,
    customerFirstName: dto.customer_first_name,
    customerLastName: dto.customer_last_name,
    customerEmail: dto.customer_email,
    customerPhone: dto.customer_phone,
    source: dto.source,
    state: dto.state,
    preferredTime: dto.preferred_time,
    validUntil: dto.valid_until,
    notes: dto.notes,
    bookingId: dto.booking_id,
    createdAt: timeZone ? moment(dto.created_at).tz(timeZone) : moment(dto.created_at),
    services: (dto.waitlist_services ?? []).map(convertToWaitlistService)
});

const convertToWaitlistTabCounts = (dto?: WaitlistTabCountsDto): WaitlistTabCounts => ({
    all: dto?.all ?? 0,
    counts: WAITLIST_SERVICE_KEYS.reduce<Partial<Record<WaitlistServiceKey, number>>>((counts, key) => {
        const count = dto?.counts?.[key];
        return count === undefined ? counts : { ...counts, [key]: count };
    }, {})
});

export const convertToWaitlistCounts = (dto: FetchWaitlistCountsResponseDto): WaitlistCounts => ({
    ...convertToWaitlistTabCounts(dto),
    expired: convertToWaitlistTabCounts(dto.expired)
});
